import ROLES from "../../roles";

export default {
  /**
   * @path http://localhost:8081/#/bulldings
   * Prevent user from some towing acitons
   */
  CAN_SEE_STATUS: [ROLES.ADMIN, ROLES.MANAGER],
  TOWINGS_EDIT: [ROLES.ADMIN, ROLES.MANAGER, ROLES.TOW_DRIVER],
  CAN_REOPEN: [ROLES.ADMIN, ROLES.MANAGER, ROLES.TOW_DRIVER],
  CAN_DELETE_VIOLATIONS: [
    ROLES.ADMIN,
    ROLES.TOW_COMPANY,
    ROLES.MANAGER,
    ROLES.LEASING_STAFF,
  ],
  CAN_DELETE_CLOSED_VIOLATIONS: [ROLES.ADMIN, ROLES.TOW_COMPANY],
  CAN_SET_ENFORCEMENT_DATE: [ROLES.TOW_DRIVER, ROLES.LEASING_STAFF],
  CAN_EDIT_COMMUNITY_NOTES: [ROLES.ADMIN, ROLES.MANAGER, ROLES.LEASING_STAFF],
  CAN_EDIT_ENFORCEMENT_NOTES: [
    ROLES.ADMIN,
    ROLES.TOW_COMPANY,
    ROLES.TOW_DRIVER,
  ],
  CAN_UPLOAD_ENFORCEMENT_IMAGES: [
    ROLES.ADMIN,
    ROLES.TOW_COMPANY,
    ROLES.TOW_DRIVER,
    ROLES.MANAGER,
    ROLES.LEASING_STAFF,
  ],
};



// WEBPACK FOOTER //
// ./src/roles/rules/towings/index.js